"use strict";

module.exports = require("./is-implemented")() ? Number.isNaN : require("./shim");



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/es5-ext/number/is-nan/index.js
// module id = ../../../../es5-ext/number/is-nan/index.js
// module chunks = 4